var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoxedPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 25.361 25.362",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.862,0H1.5C0.672,0,0,0.673,0,1.5v22.36c0,0.827,0.672,1.5,1.5,1.5h22.361c0.828,0,1.5-0.673,1.5-1.5V1.5 C25.362,0.673,24.689,0,23.862,0z M22.362,22.363H3V3h19.361L22.362,22.363L22.362,22.363z M4.555,12.682 c0-0.829,0.672-1.5,1.5-1.5h5.125V6.057c0-0.828,0.672-1.5,1.5-1.5c0.828,0,1.5,0.672,1.5,1.5v5.125h5.125 c0.828,0,1.5,0.672,1.5,1.5c0,0.828-0.672,1.5-1.5,1.5H14.18v5.125c0,0.828-0.672,1.5-1.5,1.5c-0.828,0-1.5-0.672-1.5-1.5v-5.125 H6.055C5.227,14.182,4.555,13.51,4.555,12.682z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxedPlus);
export default __webpack_public_path__ + "static/media/boxed-plus.5faae3b1fda6d82ec13bb243705ec3e7.svg";
export { ForwardRef as ReactComponent };